// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-345011d3] { color: blue !important;\n}\n.stale-row[data-v-345011d3] { background-color: #FFF3E0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
